//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'
import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'

export default {
  components: {
    Button,
    ModalWithTitleBar,
  },
  props: {
    collaborators: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    columns: [
      {
        field: 'name',
      },
    ],
    filter: '',
    windowWidth: window.innerWidth,
  }),
  computed: {
    filteredCollaborators() {
      const searchText = this.filter ? this.filter.trim().toLowerCase() : null

      if (!searchText) {
        return this.collaborators
      }

      return this.collaborators.filter((supervisor) => {
        let matchesSearchText = false
        if (searchText) {
          const name = (supervisor.name || '').toLowerCase()
          matchesSearchText = name.includes(searchText)
        }
        if (searchText) {
          return matchesSearchText
        }
        return false
      })
    },
    modalWidth() {
      return this.windowWidth < 768 ? 328 : 640
    },
  },
  methods: {
    onClose() {
      this.$emit('close', true)
    },
    goToCollaborators() {
      this.$emit('go-to-collaborators')
    },
  },
}
